module.exports = __webpack_public_path__ + "img/ic_country_problem.6ad58575.png";